/**
 * FinanceLayout — теперь просто wrapper для контента финансовых страниц.
 * Сайдбар управляется глобальным AppShell, который на finance.<домен>
 * рендерит финансовые NAV-айтемы вместо дашбордных.
 */
import type { ReactNode } from "react";

export function FinanceLayout({ children }: { children: ReactNode }) {
  return (
    <div className="page">
      {children}
    </div>
  );
}
